import { LayerDefinition } from './types'

import ActivitiesLayer from './ActivitiesLayer'
import VehicleSourceActivitiesLayer from './VehicleSourceActivitiesLayer'
import ChangeAreasLayer from './ChangeAreasLayer'
import GridLayer from './GridLayer'
import PeriodSelectionsLayer from './PeriodSelectionsLayer'
import PlacesLayer from './PlacesLayer'
import CardInsertsLayer from './CardInsertsLayer'
import DayActivitiesLayer from './DayActivitiesLayer'
import NightWorkDaysLayer from './NightWorkDaysLayer'
import DailyRestsLayer from './DailyRestsLayer'
import DailyPartialRegularRestsLayer from './DailyPartialRegularRestsLayer'
import BreaksLayer from './BreaksLayer'
import PartialBreaksLayer from './PartialBreaksLayer'
import WeeklyRestsLayer from './WeeklyRestsLayer'
import WeeklyReducedRestsLayer from './WeeklyReducedRestsLayer'
import WeekRecompensesLayer from './WeekRecompensesLayer'
import TmsDataLayer from './TmsDataLayer'
import OutOfScopesLayer from './OutOfScopesLayer'
import DelegationMarkersLayer from './DelegationMarkersLayer'
import MinimalPaymentCountriesLayer from './MinimalPaymentCountriesLayer'
import ViolationsLayer from './ViolationsLayer'
import RestPartsLayer from './RestPartsLayer'
import ExistingDelegationsLayer from './ExistingDelegationsLayer'
import CurrentDelegationsLayer from './CurrentDelegationsLayer'
import CurrentDelegationTimesLayer from './CurrentDelegationTimesLayer'


export const LAYERS: LayerDefinition[] = [
  { id: 'changeAreas', zIndex: 0, isVisible: () => true, Component: ChangeAreasLayer },
  {
    id: 'existingDelegations',
    zIndex: 0,
    isVisible: (f) => f.showTrips,
    Component: ExistingDelegationsLayer,
  },
  {
    id: 'currentDelegations',
    zIndex: 0,
    isVisible: () => true,
    Component: CurrentDelegationsLayer,
  },
  {
    id: 'minimalPaymentCountries',
    zIndex: 2,
    isVisible: () => true,
    Component: MinimalPaymentCountriesLayer,
  },
  {
    id: 'restParts',
    zIndex: 104,
    isVisible: (f) => f.showRestParts,
    Component: RestPartsLayer,
  },
  { id: 'activities', zIndex: 20, isVisible: () => true, Component: ActivitiesLayer },
  {
    id: 'vehicleSourceActivities',
    zIndex: 21,
    isVisible: () => true,
    Component: VehicleSourceActivitiesLayer,
  },
  { id: 'outOfScopes', zIndex: 0, isVisible: (f) => !f.simpleMode, Component: OutOfScopesLayer },
  { id: 'places', zIndex: 106, isVisible: (f) => !f.simpleMode, Component: PlacesLayer },
  {
    id: 'delegationMarkers',
    zIndex: 107,
    isVisible: (f) => f.showDelegations,
    Component: DelegationMarkersLayer,
  },
  { id: 'cardInserts', zIndex: 50, isVisible: (f) => !f.simpleMode, Component: CardInsertsLayer },
  {
    id: 'dailyRests',
    zIndex: 50,
    isVisible: (f) => !f.simpleMode && f.showRests,
    needsLanes: true,
    Component: DailyRestsLayer,
  },
  {
    id: 'dailyPartialRegularRests',
    zIndex: 50,
    isVisible: (f) => !f.simpleMode && f.showRests,
    needsLanes: true,
    Component: DailyPartialRegularRestsLayer,
  },
  {
    id: 'breaks',
    zIndex: 50,
    isVisible: (f) => !f.simpleMode && f.showRests,
    needsLanes: true,
    Component: BreaksLayer,
  },
  {
    id: 'partialBreaks',
    zIndex: 50,
    isVisible: (f) => !f.simpleMode && f.showRests,
    needsLanes: true,
    Component: PartialBreaksLayer,
  },
  {
    id: 'weeklyReducedRests',
    zIndex: 50,
    isVisible: (f) => f.simpleMode || f.showRests,
    needsLanes: true,
    Component: WeeklyReducedRestsLayer,
  },
  {
    id: 'weeklyRests',
    zIndex: 50,
    isVisible: (f) => f.simpleMode || f.showRests,
    needsLanes: true,
    Component: WeeklyRestsLayer,
  },
  {
    id: 'weekRecompenses',
    zIndex: 50,
    isVisible: (f) => f.simpleMode || f.showRests,
    Component: WeekRecompensesLayer,
  },
  { id: 'tmsData', zIndex: 100, isVisible: () => true, Component: TmsDataLayer },
  {
    id: 'periodSelections',
    zIndex: 102,
    isVisible: (f) => !f.simpleMode && f.editMode,
    Component: PeriodSelectionsLayer,
  },
  { id: 'grid', zIndex: 103, isVisible: () => true, Component: GridLayer },
  {
    id: 'dayActivities',
    zIndex: 104,
    isVisible: (f) => !f.simpleMode && f.showDayActivities,
    Component: DayActivitiesLayer,
  },
  {
    id: 'nightWorkDays',
    zIndex: 104,
    isVisible: (f) => !f.simpleMode && f.showDayActivities,
    Component: NightWorkDaysLayer,
  },
  {
    id: 'currentDelegationTimes',
    zIndex: 104,
    isVisible: () => true,
    Component: CurrentDelegationTimesLayer,
  },
  {
    id: 'violations',
    zIndex: 105,
    isVisible: (f) => f.showViolations,
    Component: ViolationsLayer,
  },
]
